/**
 * Does anything on this patient demand review before collecting?
 *
 * Hoisted from two verbatim copies — PatientResponsibilityPanel and the
 * v2 PatientDetailView (deleted in gdn-3189, unmounted since April) —
 * that had drifted in a way duplication hid: the
 * bodies were identical, but the panel fed it `realEncounters` (filtered
 * to rows with a non-null encounter_id) while v2 fed it the raw list. An
 * account-level row carrying a suppressing action therefore triggered
 * review on one surface and not the other.
 *
 * Unified on the UNFILTERED list, decided 2026-08-28: account-level rows
 * count, deliberately. "Does anything here demand review" includes them,
 * and the balance table renders account-level rows with their own verbs,
 * so Review Balances has something actionable to show when one triggers.
 *
 * Since gdn-3175 this only decides which act LEADS — Collect payment is
 * never hidden — so a broader trigger costs emphasis, not capability,
 * and under-triggering is the worse error.
 */
const REVIEW_FIRST_ACTIONS = [
  'void_invoice',
  'suspend_invoice_wait_secondary',
  'review_credit_or_refund',
  'review_denial',
] as const;

export function hasCollectionSuppressedReconciliation(
  encounters: unknown[] | null | undefined,
): boolean {
  return (encounters ?? []).some(encounter => {
    const action = (
      encounter as {
        patient_responsibility_reconciliation?: { recommended_action?: string | null } | null;
      }
    ).patient_responsibility_reconciliation?.recommended_action;
    return REVIEW_FIRST_ACTIONS.includes(action as (typeof REVIEW_FIRST_ACTIONS)[number]);
  });
}
